import BlogPostListings from 'blog_posts/scripts/blog_post_listings'

$(function () {
  BlogPostListings.init()
})
